<div class="page">
  <ng-container *ngIf="!sectionReady">
    <app-spinner></app-spinner>
  </ng-container>

  <ng-container *ngIf="sectionReady">
    <tyt-one-time-contribution [step]="secondarySectionId"></tyt-one-time-contribution>
  </ng-container>
</div>
